export default {
  headers: [
    ['satellite-tracking/report.date', 'day'],
    ['satellite-tracking/report.drivers', 'drivers'],
    ['satellite-tracking/report.driving_time', 'drivingTime'],
    ['satellite-tracking/report.idle_vehicle_operation', 'idleTime'],
    ['satellite-tracking/report.total_duration', 'totalDuration']
  ]
}
